/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Qrcode_ValidInputs */

const en__field_qrcode_valid = /** @type {(inputs: _Field_Qrcode_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long should the QRcode for the participation confirmation be valid for, after the event ended?`)
};

const de__field_qrcode_valid = /** @type {(inputs: _Field_Qrcode_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange soll der QR Code für die Teilnahmebestätigung über das Ende der Veranstaltung hinaus gültig sein?`)
};

/**
* | output |
* | --- |
* | "How long should the QRcode for the participation confirmation be valid for, after the event ended?" |
*
* @param {_Field_Qrcode_ValidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_qrcode_valid = /** @type {((inputs?: _Field_Qrcode_ValidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Qrcode_ValidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_qrcode_valid(inputs)
	return de__field_qrcode_valid(inputs)
});